import { render, staticRenderFns } from "./ProductCategorySection.vue?vue&type=template&id=ffb3c6e6"
import script from "./ProductCategorySection.vue?vue&type=script&lang=js"
export * from "./ProductCategorySection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports